module.exports = __webpack_public_path__ + "img/green-2-diamond-solid.4ff141e7.svg";